import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { createContext } from 'react';
export const AnnotationsDraftContext = /*#__PURE__*/createContext(null);
export const ProvidersContext = /*#__PURE__*/createContext(null);
export const InlineCommentsStateContext = /*#__PURE__*/createContext({});
export class AnnotationsDraftContextWrapper extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      position: null
    });
    _defineProperty(this, "applyAnnotationDraftAt", nextPosition => {
      const {
        setDraftRange
      } = this.props;

      // Set the draft range to preserve it downstream
      setDraftRange();

      // We need to support a new draft being made while one exists and overwrite it
      // Set the document position for the newly created draft
      this.setState({
        position: nextPosition
      });
    });
    _defineProperty(this, "clearAnnotationDraft", () => {
      const {
        clearDraftRange
      } = this.props;

      // Clear the draft range
      clearDraftRange();

      // Clear the draft position in the document
      this.setState({
        position: null
      });
    });
  }
  render() {
    const {
      children
    } = this.props;
    const {
      position
    } = this.state;
    const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
    const clearAnnotationDraft = this.clearAnnotationDraft;
    return /*#__PURE__*/React.createElement(AnnotationsDraftContext.Provider, {
      value: position
    }, children({
      applyAnnotationDraftAt,
      clearAnnotationDraft
    }));
  }
}